export function trackPixelEvent(eventName: string, params?: Record<string, unknown>) {
  if (typeof window !== 'undefined' && (window as Record<string, unknown>).fbq) {
    ((window as Record<string, unknown>).fbq as (event: string, name: string, data?: Record<string, unknown>) => void)('track', eventName, params);
  }
}

export function trackContact() {
  trackPixelEvent('Contact');
}